import { render, staticRenderFns } from "./SelectGlobalLanguage.vue?vue&type=template&id=1058fd81"
import script from "./SelectGlobalLanguage.vue?vue&type=script&lang=js"
export * from "./SelectGlobalLanguage.vue?vue&type=script&lang=js"
import style0 from "./SelectGlobalLanguage.vue?vue&type=style&index=0&id=1058fd81&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports